<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Analisis de cotizaciones</h4>
            </div>
            <br>
            <div class="card-body">
                <form class="form-horizontal">
                    <div class="form-body">
                        <h3 class="box-title">Información Básica del cliente</h3>
                        <div style="float: right;">
                            <!-- ===================================== -->
                            <!-- ======== BOTÓN PARA IMPRIMIR ======== -->
                            <!-- ===================================== -->
                            <button class="btn btn-circle botonImprimir btn-lg" *ngIf="btnImprimir; else imprimirJustificacion" (click)="print()"><i class="mdi mdi-printer"></i></button>
                            <ng-template #imprimirJustificacion>
                                <button class="btn btn-circle botonImprimir btn-lg" data-toggle="modal" data-target="#laJustificacion"><i class="mdi mdi-printer"></i></button>
                            </ng-template>
                            <!-- *ngIf="botonesPermisos.crearContrato" -->
                            <!-- ===================================== -->
                            <!-- ======== BOTÓN PARA IMPRIMIR ======== -->
                            <!-- ===================================== -->
                            <!-- ===================================== -->
                            <!-- ======== MODAL JUSTIFICACIÓN ======== -->
                            <!-- ===================================== -->
                            <div class="modal fade" id="laJustificacion" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="float float-none">Jusitificación</h4>
                                            <br>
                                        </div>
                                        <div class="modal-body">
                                            <FORM class="form-horizontal form-material">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <textarea class="form-control col-md-12 col-lg-12" rows="4" placeholder="Justificación..." [(ngModel)]="formJustificacion" name="formJustificacion"></textarea>
                                                    </div>
                                                </div>
                                            </FORM>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-info waves-effect" data-dismiss="modal" (click)="print()">
                                                Guardar/Imprimir cotización
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- ===================================== -->
                            <!-- ======== MODAL JUSTIFICACIÓN ======== -->
                            <!-- ===================================== -->
                        </div>
                        <hr class="m-t-0 m-b-40">
                        <!-- ========================================== -->
                        <!-- ===== INFORMACIÓN BÁSICA DEL CLIENTE ===== -->
                        <!-- ========================================== -->
                        <div class="col-md-12 col-xl-6 float-left">
                            <div class="col-md-6">
                                <label>Cliente: </label>
                                <input class="form-control" name="elCliente" [(ngModel)]="formCliente" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-6">
                                <label>Contacto: </label>
                                <input class="form-control" name="elContacto" [(ngModel)]="formContacto" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-6">
                                <label>Nombre de la obra: </label>
                                <input class="form-control" name="descrip" [(ngModel)]="formDescripcion" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-6">
                                <label>Teléfono: </label>
                                <input class="form-control" name="laFecha" [dropSpecialCharacters]="true" mask="(00) 000000-000000" [(ngModel)]="formTelefono" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-6">
                                <label>Celular: </label>
                                <input class="form-control" name="elCel" [dropSpecialCharacters]="true" mask="(00) 000000-000000" [(ngModel)]="formCelular" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-6">
                                <label>Email: </label>
                                <input class="form-control" name="elEmail" [(ngModel)]="formEmail" [disabled]="boolCotizacionAceptada">
                            </div>
                            <div class="col-md-12">
                                <label class="col-md-6">Fecha: 
                                    <h3>{{ fechaCotizacionFormato }}</h3>
                                    <!--
                                    <h3>{{fechaCotizacion}}</h3>
                                    -->
                                </label>
                            </div>
                            <div class="col-md-12">
                                <label>Tipo de cotización</label>
                                <select class="form-control" [(ngModel)]="ordenTipo" name="ordenTipo" style="width: 160px" (ngModelChange)="selectTipoCotizacion()" [disabled]="boolCotizacionAceptada">
                                    <option value="Montaje">{{ selectMontaje }}</option> 
                                    <option value="Venta">{{ selectVenta }}</option>
                                    <option value="Renta">{{ selectRenta }}</option>
                                </select>
                            </div>
                            <div *ngIf="ordenTipo === 'Renta' || ordenTipo === 'Venta'">
                                <label>Ahora selecciona si la venta va con flete o sin el</label>
                                <select class="form-control" style="width: 160px" name="conFlete" [(ngModel)]="conFlete" (ngModelChange)="generarFlete()" [disabled]="boolCotizacionAceptada">
                                    <!-- (ngModelChange)="recorridoMaterial()" -->
                                    <!--  (click)="tipoOrden()" -->
                                    <!--
                                    <option [value]="selectTC" *ngFor="let selectTC of selectTipoCotizacion">{{ selectTC }}</option>
                                    -->
                                    <option value= 'false'>Con Flete</option>
                                    <option value= 'true'>Sin Flete</option>
                                </select>
                            </div>
                            <!--
                            <div class="col-md-12">
                                <label>Justificación</label>
                                <input class="form-control col-md-12" [(ngModel)]="formJustificacion" name="formJustificacion">
                            </div>
                            -->
                        </div>
                        <div class="col-md-12 col-xl-6 float-right">
                            <div class="col-md-6">
                                <label>Dirección de la obra: </label>
                                <input class="form-control" name="obraCotizadaa" [(ngModel)]="formObra" [disabled]="boolCotizacionAceptada" />
                                <br>
                                <br/>
                                <input type="hidden" id="latitud" [disabled]="boolCotizacionAceptada" />
                                <input type="hidden" id="longitud" [disabled]="boolCotizacionAceptada" />
                                <input type="hidden" id="distanciaM" [disabled]="boolCotizacionAceptada" />
                                <input type="hidden" id="latitudDeSucursal" [disabled]="boolCotizacionAceptada" />
                                <input type="hidden" id="longitudDeSucursal" [disabled]="boolCotizacionAceptada" />
                                <datalist id="datalista">
                                    <option></option>
                                    <!-- *ngFor="let lista of resultados" data-value="{{lista.x}}" value="{{lista.label}}" -->
                                </datalist>
                                <!-- <button (click)="abrirMap()">abrir mapa</button> -->
                                <div id="map" style="height:350px;width: 400px;"></div>
                            </div>
                            <p style="width:400px;">Para usar el mapa haz click derecho para insertar un marcador</p>
                        </div>
                        <!-- ========================================== -->
                        <!-- ===== INFORMACIÓN BÁSICA DEL CLIENTE ===== -->
                        <!-- ========================================== -->
                        <div class="table-responsive">
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <!-- Buscar en primer dataTable -->
                            <!-- ========================== -->
                            <div class="float float-left" *ngIf="(usuario.rol === 'COMERCIAL' || usuario.rol === 'SISTEMAS') && arraySolicitudLista.length !== 0">
                                <h3>Se ha solicitado un cambio en la lista de precios a la sucursal de {{ solicitudListaNombre }}</h3>
                                <button class="btn btnAceptar" type="button" (click)="aceptarSolicitud()" [disabled]="boolCotizacionAceptada">Autorizar solicitud</button>
                                <button class="btn btnRechazar" type="button" (click)="rechazarSolicitud()" [disabled]="boolCotizacionAceptada">Rechazar solicitud</button>
                            </div>
                            <button type="button" class="btn btnCambioListaPrecios float float-right" (click)="solicitarCambioListaPrecios()" *ngIf="usuario.rol === 'TECNICO'">Solicitar cambio de lista de precios</button>
                            <input id="listaPrecio" type="hidden" />
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th colspan="4" style="text-align: center">
                                            <!--
                                            <h4 style="text-align: center">Precios pertenecientes a la sucursal {{ nombreListaSucursal }}</h3>
                                            -->
                                            Lista de precios pertenecientes a la sucursal {{ nombreListaSucursal }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Código</th>
                                        <th>Familia</th>
                                        <th>Descripción</th>
                                        <th>Agregar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let producto of arrayListarProductos">
                                        <td>{{ producto.codigo }}</td>
                                        <td>{{ producto.familia }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td>
                                            <button type="button" class="btn buscar" (click)="agregarProducto(producto)" [disabled]="boolCotizacionAceptada">Agregar</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive">
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <!-- ======================================= -->
                            <!-- Modificaciones a precios de material -->
                            <!-- ======================================= -->
                            <h3>Modificaciones a precios de material: </h3>
                            <div class="col-md-12">
                                <label>Porcentaje de aumento (%)</label>
                                <!--input id="porcentajeAu" class="form-control camposManoObra" type="number" name="porcentajeA" [(ngModel)]="porcentajeAumento" (ngModelChange)="aumento()" [disabled]="boolCotizacionAceptada" />
                                (ngModelChange)="aumento()" -->
                                <select class="form-control variosSelect" [(ngModel)]="porcentajeAumento" name="porcentajeA" (ngModelChange)="aumento()" [disabled]="boolCotizacionAceptada || !boolOrdenTipo">
                                    <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                    <!--
                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                    -->
                                </select>
                                <button class="btn btnSolicitarDescuento" *ngIf="usuario.rol === 'TECNICO' && !banderaDescuento" (click)="solicitarDescuento()" [disabled]="boolCotizacionAceptada">Solicitar descuento</button>
                                <button class="btn btnSolicitarDescuento" *ngIf="banderaDescuento" (click)="cancelarDescuento()" [disabled]="boolCotizacionAceptada">cancelarDescuento</button>
                            </div>
                            <br>
                            <div class="col-md-12" *ngIf="(usuario.rol === 'COMERCIAL' || usuario.rol === 'SISTEMAS') && estatusCotizacionDescuento === 'DESESPE'">
                                <label>Porcentaje de descuento(%)</label>
                                <input class="form-control camposManoObra" type="number" name="porcentajeD" [(ngModel)]="porcentajeDescuento" />
                                <button class="btn btnAceptar" (click)="revisarDescuento('DESAUTO')" [disabled]="boolCotizacionAceptada">Aceptar descuento</button>
                                <button class="btn btnRechazar" (click)="revisarDescuento('DESDENE')" [disabled]="boolCotizacionAceptada">Rechazar descuento</button>
                            </div>
                            <!-- ======================================= -->
                            <!-- Modificaciones a precios de material -->
                            <!-- ======================================= -->
                            <br>
                            <hr class="m-t-0 m-b-40">
                            <!-- Agregar los productos a ese dataTable -->
                            <!-- ========================== -->
                            <h3>Materiales agregados: </h3>
                            <table class="table table table-striped table-hover materialesAgregados">
                                <!-- datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%" -->
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th style="text-align: center">Código</th>
                                        <th style="text-align: center">Descripción</th>
                                        <th style="text-align: center">Cantidad</th>
                                        <th style="text-align: center">P.U. 30 días</th>
                                        <th style="text-align: center">Importe Renta</th>
                                        <!--
                                        <th>P.U. venta</th>
                                        <th>Importe Venta</th>
                                        <th>Peso Pieza (Kg)</th>
                                        -->
                                        <th style="text-align: center">Importe peso (Kg)</th>
                                        <th style="text-align: center">Eliminar elemento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let producto of arrayMaterial">
                                        <td></td>
                                        <td style="text-align: center">{{ producto.codigo }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td style="text-align: center">
                                            <input id="{{producto.codigo}}" type="number" class="form-control" name="{{producto.descripcion}}" (ngModelChange)="calculosProducto(producto)" [(ngModel)]="producto.cantidad" [disabled]="boolCotizacionAceptada">
                                        </td>
                                        <td style="text-align: center">{{ producto.rentaMensual }}</td>
                                        <td style="text-align: center">{{ producto.importeRentaImp }}</td>
                                        <!--
                                        <td>{{ producto.venta }}</td>
                                        <td>{{ producto.importeVenta }}</td>
                                        <td>{{ producto.peso }}</td>
                                        -->
                                        <td style="text-align: center">{{ producto.importePesoImp }}</td>
                                        <td style="text-align: center">
                                            <a>
                                                <!--  (click)="eliminarMaterial(producto.codigo)" -->
                                                <i class="fa fa-close text-danger" (click)="eliminarMaterial(producto)"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr class="m-t-0 m-b-40">
                        <div class="col-md-6 col-xl-6 col-sm-6 col-xs-6 float-left">
                            <!-- ================================ -->
                            <!-- ========= MANO DE OBRA ========= -->
                            <!-- ================================ -->
                            <div id="divtituloMano">Mano de Obra (Montadores) <span><i (click)="desplegarManoObra()" style="font-size: 25px" class="mdi {{ iconoMano }} waves-effect waves-dark"></i></span> (desplegable)</div>
                            <!-- Mano de obra -->
                            <div *ngIf="manoDeObraCollapse" id="divManoDeObra">
                                <table id="tablaMano">
                                    <thead>
                                        <tr><br/></tr>
                                        <th class="float-none" colspan="4" style="text-align: center"> Rendimiento (Montaje/Desmontaje)</th>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Altura:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="altura" name="altura" (ngModelChange)="generarManoDeObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="aselect" *ngFor="let aselect of alturaSelect">{{ aselect }}</option>
                                                </select>
                                                <!--
                                                <input class="form-control camposManoObra" type="number" [(ngModel)]="altura" name="altura" (ngModelChange)="generarManoDeObra()">
                                                -->
                                            </td>
                                            <td></td>
                                            <td>
                                                <!--
                                                <select class="form-control variosSelect" [(ngModel)]="personas" name="personas" (ngModelChange)="jornadas()">
                                                    <option [value]="pselect" [selected]="pselect" *ngFor="let pselect of personasSelect">{{ pselect }}</option>
                                                </select>
                                                -->
                                                <!--
                                                <input class="form-control camposManoObra" type="number" [(ngModel)]="personas" name="personas" (ngModelChange)="jornadas()">
                                                -->
                                            </td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Horas Totales: </td>
                                            <td style="color:#000000;"><b>{{ cantidadHorasTotalImp }}</b></td>
                                            <td>Jornales: </td>
                                            <td style="color:#000000;"><b>{{ jornalesImp }}</b></td>
                                        </tr>
                                        <!--
                                        <tr>
                                            <td>Horas/personas: </td>
                                            <td style="color:#000000;"><b>{{ horasPersonas }}</b></td>
                                            <td>Jornales/personas: </td>
                                            <td style="color:#000000;"><b>{{ jornalesPersonas }}</b></td>
                                        </tr>
                                        -->
                                        <tr><br/></tr>
                                    </thead>
                                    <tbody>
                                        <th class="float-none" colspan="4" style="text-align: center"> Variables de Tiempo (horas)</th>
                                        <tr><br/></tr>
                                        <tr style="border-spacing: 4">
                                            <td>Accesos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Accesos" name="Accesos" (ngModelChange)="variablesTemporales()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                            <td>Descargas:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Descargas" name="Descargas" (ngModelChange)="variablesTemporales()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tiempos muertos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="tiemposMuertos" name="tiemposMuertos" (ngModelChange)="variablesTemporales()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                            <td>Acarreos:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="Acarreos" name="Acarreos" (ngModelChange)="variablesTemporales()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tiempos Extras:</td>
                                            <td>
                                                <input class="form-control camposManoObra conceptosVarios" [(ngModel)]="tiemposExtras" name="tiemposExtras" (ngModelChange)="variablesTemporales()" [dropSpecialCharacters]="true" mask="00" [disabled]="boolCotizacionAceptada" />
                                                <!--
                                                <select class="form-control variosSelect" [(ngModel)]="tiemposExtras" name="tiemposExtras" (ngModelChange)="variablesTemporales()">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} horas</option>
                                                </select>
                                                -->
                                            </td>
                                            <td>Dias Inhabiles:</td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="diasInhabiles" name="diasInhabiles" (ngModelChange)="variablesTemporales()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }} días</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr *ngIf="diasInhabiles > 0">
                                            <td></td>
                                            <td></td>
                                            <td>Personas: </td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="personas" name="personas" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="pselect" [selected]="pselect" *ngFor="let pselect of personasSelect">{{ pselect }}</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr><br/></tr>
                                        <th class="float-none" colspan="4" style="text-align: center"> Variables Monetarias ($ pesos)</th>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Tramites:</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="Tramites" name="Tramites" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>Certificados:</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="Certificados" name="Certificados" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada"></td>
                                        </tr>
                                        <tr>
                                            <td>Consumibles Especiales:</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="consumibles" name="consumibles" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada" /></td>
                                            <td> Equipo de seguridad Adicional:</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="equipoSeguridad" name="equipoSeguridad" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada"
                                                /></td>
                                        </tr>
                                        <tr>
                                            <td> Preparacion del material:</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="Preparacion" name="Preparacion" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>Imprevistos:</td>
                                            <td>
                                                <select class="form-control" [(ngModel)]="Imprevistos" name="Imprevistos" style="width: 75px" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada">
                                                    <option value="0" selected>{{ imprevistos0 }}</option>
                                                    <option value="5">{{ imprevistos5 }}</option>
                                                    <option value="10">{{ imprevistos10 }}</option> 
                                                    <option value="15">{{ imprevistos15 }}</option>
                                                    <option value="20">{{ imprevistos20 }}</option>
                                                </select>
                                            </td>
                                            <!--
                                            <td><input class="form-control camposManoObra conceptosVarios" type="number" [(ngModel)]="Imprevistos" name="Imprevistos" (ngModelChange)="sumaConceptosVarios()"></td>
                                            -->
                                        </tr>
                                        <tr>
                                            <td>Comidas</td>
                                            <td><input class="form-control camposManoObra conceptosVarios" type="text" mask='00000' [(ngModel)]="Comidas" name="Comidas" (ngModelChange)="sumaConceptosVarios()" [disabled]="boolCotizacionAceptada"></td>
                                        </tr>
                                        <tr><br/><br><br></tr>
                                        <th class="float-none" colspan="4" style="text-align: center">Traslados del Personal (Montadores)</th>
                                        <tr><br/></tr>
                                        <tr style="text-align: center">
                                            <td>Transporte</td>
                                            <td>Costo Unidad</td>
                                            <td>Viajes/persona</td>
                                            <td>Redondo</td>
                                            <td>SubTotal</td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Avion:</td>
                                            <td><input class="form-control camposManoObra" style="text-align: center; width:70px" type="text" mask='0000' [(ngModel)]="avionCosto" name="avionCosto" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="avionViajes" name="avionViajes" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="avionCheck" [(ngModel)]="avionCheck" id="avionCheck" (ngModelChange)="generarTrasladosManoObra()"></td>
                                            <td>{{sumaAvion}}</td>
                                        </tr>
                                        <tr>
                                            <td>Autobus:</td>
                                            <td><input class="form-control camposManoObra" style="width:70px" type="text" mask='0000' [(ngModel)]="autobusCosto" name="autobusCosto" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="autobusViajes" name="autobusViajes" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="autobusCheck" [(ngModel)]="autobusCheck" id="autobusCheck" (ngModelChange)="generarTrasladosManoObra()"></td>
                                            <td>{{sumaAutobus}}</td>
                                        </tr>
                                        <tr>
                                            <td>Barco:</td>
                                            <td><input class="form-control camposManoObra" style="width:70px" type="text" mask='0000' [(ngModel)]="barcoCosto" name="barcoCosto" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="barcoViajes" name="barcoViajes" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td style="text-align: center"><input type="checkbox" name="barcoCheck" [(ngModel)]="barcoCheck" id="barcoCheck" (ngModelChange)="generarTrasladosManoObra()"></td>
                                            <td>{{sumaBarco}}</td>
                                        </tr>
                                        <tr>
                                            <td>Taxi:</td>
                                            <td><input class="form-control camposManoObra" style="width:70px" type="text" mask='0000' [(ngModel)]="taxiCosto" name="taxiCosto" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="taxiViajes" name="taxiViajes" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td></td>
                                            <td>{{sumaTaxi}}</td>
                                        </tr>
                                        <tr>
                                            <td>Otro:</td>
                                            <td><input class="form-control camposManoObra" style="width:70px" type="text" mask='0000' [(ngModel)]="otroCosto" name="otroCosto" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada"></td>
                                            <td>
                                                <select class="form-control variosSelect" [(ngModel)]="otroViajes" name="otroViajes" (ngModelChange)="generarTrasladosManoObra()" [disabled]="boolCotizacionAceptada">
                                                    <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                </select>
                                            </td>
                                            <td></td>
                                            <td>{{sumaOtro}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{{sumaTrasladosTotalImp}}</td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td>Montaje: </td>
                                            <td style="color:#000000;"><b>{{ montajeImp }}</b></td>
                                            <td></td>
                                            <td>Desmonataje: </td>
                                            <td style="color:#000000;"><b>{{ desmontajeImp }}</b></td>
                                        </tr>
                                        <tr><br/></tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>Total:</td>
                                            <td style="color:#000000;"><b>{{totalTotalImp}}</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div id="divtituloMano">Mano de Obra (Montadores) <span><i (click)="desplegarManoObra()" style="font-size: 25px" class="mdi {{ iconoMano }} waves-effect waves-dark"></i></span> (desplegable)</div>
                            </div>
                            <!-- ================================ -->
                            <!-- ========= MANO DE OBRA ========= -->
                            <!-- ================================ -->
                            <br>
                            <!-- ========================== -->
                            <!-- ========= FLETES ========= -->
                            <!-- ========================== -->
                            <div>
                                <div id="divtituloFletes">Calculo de Fletes (Operadores) <span><i (click)="desplegarFlete()" style="font-size: 25px" class="mdi {{ iconoFlete }} waves-effect waves-dark"></i></span> (desplegable)</div>
                                <!-- Todo lo que va a esconderse-->
                                <div *ngIf="fletesCollapse" id="divFletes">
                                    <!-- La tabla para gurdar los valores de los gastos vehiculares-->
                                    <br/>
                                    <h3 style="text-align: center">Gastos vehiculares</h3>
                                    <table>
                                        <thead>
                                            <tr>
                                                <td style="text-align: center;" colspan="3" hidden>Gastos Vehiculares</td>
                                            </tr>
                                            <br>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Vehiculo recomendado: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ vehiculoNombre }}</b></td>
                                            </tr>
                                            <tr *ngIf="banderaVehiculo2">
                                                <td>Vehiculo recomendado: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ vehiculo2Nombre }}</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Distancia: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>{{ distanciaKmImp }} Kilómetros.</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Precio Gasolina: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ vehiculoCombustiblePrecio }} pesos</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Gastos Gasolina: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ gastoCombustibleVistaImp }} pesos</b></td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>casetas: $</td>
                                                <td></td>
                                                <td style="text-align: center">
                                                    <input class="form-control" style="width:70px; text-align: center" type="text" mask='0000' id="casetas" name="casetas" [(ngModel)]="gastoCasetas" (ngModelChange)="generarFlete()" [disabled]="boolCotizacionAceptada">
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Imprevistos: </td>
                                                <td></td>
                                                <td style="text-align: center">
                                                    <select class="form-control selectImprevistos" [(ngModel)]="gastoExtra" name="gastoExtra" (ngModelChange)="generarFlete()" [disabled]="boolCotizacionAceptada">
                                                        <option [value]="imprevisto" *ngFor="let imprevisto of imprevistos">${{ imprevisto }} pesos</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Recolección: </td>
                                                <td></td>
                                                <td style="text-align: center"><input type="checkbox" name="checkRecoleccion" id="checkRecoleccion" [(ngModel)]="checkRecoleccion" (ngModelChange)="generarFlete()" [disabled]="boolCotizacionAceptada">
                                                </td>
                                            </tr>
                                            <br>
                                            <tr>
                                                <td>Total: </td>
                                                <td></td>
                                                <td style="text-align: center"><b>${{ operacionTotalVehicularesVistaImp }} pesos</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <hr class="mt-5 m-b-40 ">
                                    <!-- La otra tabla para los viaticos de los Operadores-->
                                    <h3 style="text-align: center">Viáticos</h3>
                                    <table>
                                        <thead>
                                            <td style="text-align: center;" colspan="4" hidden>Viaticos</td>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="text-align: center">Concepto &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;</td>
                                                <td></td>
                                                <td style="text-align: center">costo unitario &nbsp;&nbsp;</td>
                                                <td style="text-align: center">cantidad dias/veces &nbsp;&nbsp;</td>
                                                <td></td>
                                                <td style="text-align: center">Subtotal</td>
                                            </tr>
                                            <tr><br/></tr>
                                            <tr>
                                                <td style="text-align: left">Alojamiento</td>
                                                <td></td>
                                                <td style="text-align: center">{{ alojamientoInput }}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" [(ngModel)]="alojamientoDias" name="alojamientoDias" (ngModelChange)="fletesViaticos()" [disabled]="boolCotizacionAceptada">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                        <!--
                                                        <option [value]="numero" *ngFor="let numero of numeros">{{ numero }}</option>
                                                        -->
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ acarreosTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Desayunos</td>
                                                <td></td>
                                                <td style="text-align: center">{{desayunosInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="desayunosDias" [(ngModel)]="desayunosDias" (ngModelChange)="fletesViaticos()" [disabled]="boolCotizacionAceptada">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ desayunosTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Comidas</td>
                                                <td></td>
                                                <td style="text-align: center">{{comidasInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="comidasDias" [(ngModel)]="comidasDias" (ngModelChange)="fletesViaticos()" [disabled]="boolCotizacionAceptada">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ comidasTotalImp }}</td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left">Cenas</td>
                                                <td></td>
                                                <td style="text-align: center">{{cenasInput}}</td>
                                                <td style="text-align: center">
                                                    <select class="form-control variosSelect" name="cenasDias" [(ngModel)]="cenasDias" (ngModelChange)="fletesViaticos()" [disabled]="boolCotizacionAceptada">
                                                        <option [value]="numeroViatico" *ngFor="let numeroViatico of numerosViaticos">{{ numeroViatico }}</option>
                                                    </select>
                                                </td>
                                                <td></td>
                                                <td style="text-align: center">{{ cenasTotalImp }}</td>
                                            </tr>
                                            <tr style="text-align: center">
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{{ totalViaticosImp }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <!-- La otra tabla para los viajes del personal-->
                                    <div class="float-center">
                                        <h3>Total fletes: ${{ totalFletesImp }} pesos</h3>
                                    </div>
                                    <div id="divtituloFletes">Calculo de Fletes (Operadores) <span><i (click)="desplegarFlete()" style="font-size: 25px" class="mdi {{ iconoFlete }} waves-effect waves-dark"></i></span> (desplegable)</div>
                                </div>
                            </div>
                            <!-- ========================== -->
                            <!-- ========= FLETES ========= -->
                            <!-- ========================== -->
                            <br>
                        </div>
                        <div class="col-md-12 col-xl-6 float-right">
                            <!-- id="tablaResumenServicio" -->
                            <!-- Resumen de servicio -->
                            <!-- ========================== -->
                            <!-- En Tabla: bgcolor="#bfbfbf" -->
                            <!-- ========================== -->
                            <!--Renta por X días  -->
                            <!-- ========================== -->
                            <table class="display nowrap table">
                                <tbody>
                                    <tr>
                                        <th>Renta diaria: </th>
                                        <th>$ {{ rentaDiariaImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 7 días: </th>
                                        <th>$ {{ rentaSdiasImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 15 días: </th>
                                        <th>$ {{ rentaQdiasImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Renta 30 días: </th>
                                        <th>$ {{ sumaRentaImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Total de piezas: </th>
                                        <th>{{ sumaCantidadImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Peso total (Kg) : </th>
                                        <th>{{ sumaPesoImp }}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ================================ -->
                            <!-- ======= Renta por X días ======= -->
                            <!-- ================================ -->
                            <!-- ================================================= -->
                            <!-- ============== RESUMEN DE SERVICIO ============== -->
                            <!-- ================================================= -->
                            <table class="display nowrap table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="float-none tablaResumenServicio" colspan="2" style="text-align: center">Resumen de servicio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="text-align: center">
                                        <th>Periodo de alquiler: </th>
                                        <!-- <th>{{contratoFechaInicio}}</th> -->
                                        <th>{{fechaCotizacionFormato}}</th>
                                    </tr>
                                    <tr style="text-align: center">
                                        <th>al: </th>
                                        <th>{{fechaFin}}</th>
                                    </tr>
                                    <tr style="text-align: center">
                                        <th>
                                            Días de renta: &nbsp;
                                            <input class="form-control" type="number" style="width: 60px" id="diasR" name="diasRenta" [(ngModel)]="diasDeRenta" (ngModelChange)="renta()" [disabled]="boolCotizacionAceptada || !boolOrdenTipo">
                                        </th>
                                        <th>Precio: $ {{ resultadoDiasRentaImp }}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ================================================= -->
                            <!-- ============== RESUMEN DE SERVICIO ============== -->
                            <!-- ================================================= -->
                            <!-- ====================================== -->
                            <!-- ============== DESGLOSE ============== -->
                            <!-- ====================================== -->
                            <table class="display nowrap table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="tablaDesglose" colspan="4" style="text-align: center">Desglose</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>Alquiler o porroga</th>
                                        <th colspan="3" style="text-align: right">$ {{resultadoDiasRentaImp}}</th>
                                    </tr>
                                    <tr>
                                        <th>Total Mano de Obra</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{ totalTotalImp }}
                                            <!--
                                            $ {{ totalManoDeObra }}
                                            -->
                                        </th>
                                    </tr>
                                    <!--
                                    <hr class="mt-5 m-b-40 ">
                                    -->
                                    <tr>
                                        <th>Fletes</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{totalFletesImp}}
                                        </th>
                                    </tr>
                                    <tr *ngIf="porcentajeDescuento !== 0">
                                        <th>Descuento aplicado: </th>
                                        <th></th>
                                        <th colspan="3" style="text-align: right">{{ porcentajeDescuento }} %</th>
                                    </tr>
                                    <tr>
                                        <th>Sub-Total sin IVA ({{ formIva }})</th>
                                        <th colspan="3" style="text-align: right">$ {{ resultadoPorcentajeDescuentoImp }}</th>
                                    </tr>
                                    <tr>
                                        <th>Venta de material/pagaré (con IVA)</th>
                                        <th colspan="3" style="text-align: right">
                                            $ {{costoVentaImp}}
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- ====================================== -->
                            <!-- ============== DESGLOSE ============== -->
                            <!-- ====================================== -->
                        </div>
                        <!-- Costo total -->
                        <div class="col-md-12 float-left">
                            <br>
                            <h2 class="col-md-6 float-left resaltar">Costo total con IVA</h2>
                            <h2 class="col-md-6 float-left resaltar">$ {{costoTotal}}</h2>
                        </div>
                        <!-- Costo total -->
                        <!-- Botones -->
                        <!-- -->
                        <div class="col-md-12 float-left">
                            <hr class="mt-5 m-b-40 ">
                            <div class="form-actions">
                                <div class="col-md-6 float-left">
                                    <button class="btn btn-block boton1" type="button" (click)="enviarCotizador()">Guardar cotización</button>
                                </div>
                                <div class="col-md-6 float-right">
                                    <button class="btn btn-block aceptarCotizacion" type="button" data-toggle="modal" data-target="#modalReferencias">Cotización aceptada por el cliente</button>
                                </div>
                                <!--
                                <div class="col-md-6 float-left">
                                    <button class="btn btn-block boton2" type="button" (click)="solicitarExistencias()">Solicitar existencias en almacén</button>
                                </div>
                                -->
                            </div>
                        </div>
                        <!-- Botones fin -->
                        <!-- ============================ -->
                        <!-- ===== Modal referencia ===== -->
                        <!-- ============================ -->
                        <div class="modal fade" id="modalReferencias" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h4 class="float float-right">Descripción de la obra</h4>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <FORM class="form-horizontal form-material">
                                            <div class="row">
                                                <div class="control-label text-left col-sm-6">
                                                    <label>Fecha de inicio</label>
                                                    <form #myForm="ngForm" novalidate class="col-md-6">
                                                        <my-date-picker id="myCalendario" date-format="yyyy-MM-dd" [options]="myDatePickerOptions" name="fechaIn" [(ngModel)]="fechaObra" required></my-date-picker>
                                                        <!-- [(ngModel)]="fechaDeInicio" -->
                                                    </form>
                                                </div>
                                                <div class="col-sm-6">
                                                    <label>Hora de entrega</label>
                                                    <input class="form-control" type="time" name="laHora" [(ngModel)]="horaObra">
                                                </div>
                                                <div class="col-sm-12">
                                                    <label>Referencia de la obra: <span class="help"> </span></label>
                                                    <textarea class="form-control letras" rows="3" name="laReferencia" [(ngModel)]="referencia"></textarea>
                                                </div>
                                            </div>
                                        </FORM>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-info waves-effect botonconfirmar" type="button" data-dismiss="modal" (click)="aceptarCotizacion()">
                                            <!--  (click)="enviarTicket()" -->
                                            Aceptar cotización
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ============================ -->
                        <!-- ===== Modal referencia ===== -->
                        <!-- ============================ -->
                    </div>
                </form>
            </div>
            <!-- ======================================= -->
            <!-- ============ PARA IMPRIMIR ============ -->
            <!-- ======================================= -->
            <div id="print-section" style="display:none;">
                <!-- style="display:none;" -->
                <table class="tablaMedida">
                    <!-- class="letraImprimir" class="tablaMedida" -->
                    <!-- class="tamagnoCeldas" style="height: 2px;" -->
                    <!--
                    <th rowspan="1" style="text-align: right">Sucursal: Guadalajara</th>
                    -->
                    <tr style="text-align: center">
                        <th rowspan="6" style="text-align: left">
                            <!-- colspan="2" rowspan="4" -->
                            <img src="../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                        </th>
                        <th colspan="2" class="letraImprimir" style="text-align: center">Sucursal: <strong> {{ sucursalNombre }} </strong> </th>
                    </tr>
                    <tr style="text-align: left">
                        <th colspan="2" class="letraImprimir" style="text-align: center">{{ surusalDireccion }}</th>
                    </tr>
                    <tr style="text-align: left">
                        <th colspan="2" class="letraImprimir" style="text-align: center">Tel: {{ sucursalTelefono }}</th>
                    </tr>
                    <!-- PRUEBA -->
                    <tr style="text-align: left">
                        <th class="letraImprimir" style="text-align: left">Cliente: {{ formCliente }}</th>
                    </tr>
                    <tr style="text-align: left">
                        <th class="letraImprimir" style="text-align: left">Contacto: {{ formContacto }} </th>
                    </tr>
                    <tr style="text-align: left">
                        <th class="letraImprimir" style="text-align: left">Obra: {{ formDescripcion }}</th>
                    </tr>
                </table>
                <br>
                <!--
                <table class="tablaMedida">
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Cliente: {{ formCliente }}</th>
                        
                        <th class="letraImprimir" style="text-align: left">Fecha: {{ fechaCotizacion }}</th>
                        
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Contacto: {{ formContacto }} </th>
                        
                        <th class="letraImprimir" style="text-align: left">Teléfono: {{formTelefono}} Celular: {{formCelular}} </th>
                        
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Obra: {{ formObra }}</th>
                    </tr>
                    
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Obra: {{ formObra }}</th>
                        <th class="letraImprimir" style="text-align: left">Email: {{ formEmail }}</th>
                    </tr>
                    
                </table>
                -->
                <hr>
                <div *ngIf="btnImprimir; else impresionJustificacion">
                    <br>
                    <table class="letraImprimir">
                        <thead>
                            <tr>
                                <th style="text-align: center">Código</th>
                                <th style="text-align: center">Descripción</th>
                                <th style="text-align: center">Cantidad</th>
                                <th style="text-align: center">P.U. 30 días</th>
                                <th style="text-align: center">Importe Renta</th>
                                <th style="text-align: center">P.U. venta</th>
                                <th style="text-align: center">Importe Venta</th>
                                <th style="text-align: center">Peso Pieza (Kg)</th>
                                <th style="text-align: center">Totales peso (Kg)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <br>

                            <tr *ngFor="let producto of arrayMaterial; index as i ">
                                <td style="text-align: center">{{ producto.codigo }}</td>
                                <td style="text-align: left">{{ producto.descripcion }}</td>
                                <td style="text-align: center">{{ producto.cantidadImp }}</td>
                                <td style="text-align: center">{{ producto.rentaMensual }}</td>
                                <td style="text-align: center">{{ producto.importeRentaImp }}</td>
                                <td style="text-align: center">{{ producto.ventaImp }}</td>
                                <td style="text-align: center">{{ producto.importeVentaImp }}</td>
                                <td style="text-align: center">{{ producto.peso }}</td>
                                <td style="text-align: center">{{ producto.importePesoImp }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <ng-template #impresionJustificacion>
                    <h3>Montaje</h3>
                    <p>{{ formJustificacion }}</p>
                </ng-template>
                <br>
                <!-- Tabla: totales de lista de material -->
                <!--
                <table class="letraImprimir">
                    <tr style="text-align: left">
                        <th colspan="4" style="text-align: left">Peso total (Kg.): {{ sumaPeso }}</th>
                        <th colspan="4" style="text-align: left">Precio por día: $ 5523523 </th>
                    </tr>
                    <tr style="text-align: right">
                        <th colspan="4" style="text-align: right">Costo en renta de los materiales</th>
                        <th colspan="4" style="text-align: right">Días de renta ({{ diasDeRenta }}): $ {{ resultadoDiasRenta }}</th>
                    </tr>
                </table>
                -->
                <!-- Tabla: totales de lista de material -->
                <hr>
                <!-- Tabla de prueba -->
                <table class="tablaMedida">
                    <!-- class="letraImprimir" colspan="4" -->
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Costo armado de equipo: </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ montajeImp }}</th>
                        <th class="letraImprimir" style="text-align: left">Dirección </th>
                        <th class="letraImprimir" style="text-align: left">{{ formObra }}</th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Costo desarmado de equipo: </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ desmontajeImp }}</th>
                        <th class="letraImprimir" style="text-align: left">Peso total (Kg.): </th>
                        <th class="letraImprimir" style="text-align: left"> {{ sumaPesoImp }} </th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Costo de flete: </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ totalFletesImp }}</th>
                        <th class="letraImprimir" style="text-align: left">Días de renta ( <strong> {{ diasDeRenta }} </strong> ): </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ resultadoDiasRentaImp }} </th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Recolección: </th>
                        <th *ngIf="checkRecoleccion; else sinRecoleccion" class="letraImprimir" style="text-align: left"> Si </th>
                        <ng-template #sinRecoleccion>
                            <th class="letraImprimir" style="text-align: left"> No </th>
                        </ng-template>

                        <th class="letraImprimir" style="text-align: left">Precio por día: </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ rentaDiariaImp }}</th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Costo en renta de los materiales</th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ resultadoDiasRentaImp }}</th>
                        <th class="letraImprimir" style="text-align: left">IVA: </th>
                        <th class="letraImprimir" style="text-align: left"> {{formIva}}</th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: left">Costo Subtotal: </th>
                        <th class="letraImprimir" style="text-align: left"> $ {{ subtotalImp }}</th>
                        <th class="letraImprimir" style="text-align: left">Pagaré: </th>
                        <th class="letraImprimir" style="text-align: left"><strong> $ {{sumaVentaImp}}</strong></th>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <th class="letraImprimir" style="text-align: left"><strong>Costo Total: </strong></th>
                        <th class="letraImprimir" style="text-align: left"><strong> $ {{ costoTotal }}</strong></th>
                    </tr>
                </table>
                <br>
                <hr>
                <!--
                <table class="letraImprimir tablaMedida">
                    <tr>
                        <th colspan="5" style="text-align: right">Costo de subtotal:</th>
                        <th style="text-align: center">IVA:</th>
                        <th style="text-align: left">Total:</th>
                    </tr>
                    <tr>
                        <th colspan="5" style="text-align: right">$ 666</th>
                        <th style="text-align: center">$ 666</th>
                        <th style="text-align: left">$ 666</th>
                    </tr>
                </table>
                <hr>
                -->
                <table class="tablaMedida">
                    <!-- siguiente tabla -->
                    <tr>
                        <th class="letraImprimir" style="text-align: center"><strong>Banco</strong></th>
                        <!--  class="tablas" -->
                        <th class="letraImprimir" style="text-align: center"><strong>Sucursal</strong></th>
                        <th class="letraImprimir" style="text-align: center"><strong>No. de cuenta</strong></th>
                        <th class="letraImprimir" colspan="2" style="text-align: center"><strong>clabe interbancaria</strong></th>
                        <!--
                        <th colspan="2" style="text-align: left">Costo Subtotal: $ 666</th>
                        id="lineaDivisora"
                        -->
                        <th class="letraImprimir" style="text-align: left"><strong>Referencia: </strong></th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: center">Banorte</th>
                        <th class="letraImprimir" style="text-align: center">****</th>
                        <th class="letraImprimir" style="text-align: center">02 84 09 97 69</th>
                        <th class="letraImprimir" colspan="2" style="text-align: center">072 180 002 840 997 698</th>
                        <!--
                        <th colspan="2" style="text-align: left">IVA: $ 666</th>
                        -->
                        <th class="letraImprimir" style="text-align: left">TQL01</th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: center">Banamex</th>
                        <th class="letraImprimir" style="text-align: center">7008</th>
                        <th class="letraImprimir" style="text-align: center">32 29 932</th>
                        <th class="letraImprimir" colspan="2" style="text-align: center">002 180 700 832 299 320</th>
                        <!--
                        <th colspan="2" rowspan="2" style="text-align: left">Costo Total: $ 666</th>
                        -->
                        <th class="letraImprimir" style="text-align: left">RFC: </th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" style="text-align: center">Santander</th>
                        <th class="letraImprimir" style="text-align: center">****</th>
                        <th class="letraImprimir" style="text-align: center">65-50512419-2</th>
                        <th class="letraImprimir" colspan="2" style="text-align: center">014 180 655 051 241 920</th>
                        <th class="letraImprimir" style="text-align: left">SMS-150513-7Y3</th>
                    </tr>
                    <!--
                    <tr>
                        <th colspan="4" style="text-align: right">Referencia</th>
                        <th colspan="4" style="text-align: left">TQL 01</th>
                    </tr>
                    <tr>
                        <th colspan="4" style="text-align: right">RFC</th>
                        <th colspan="4" style="text-align: left">SMS-150513-7Y3</th>
                    </tr>
                    -->
                </table>
                <hr>
                <h3 class="letraContratacion" style="text-align: left"><strong>Requisitos para contratación</strong></h3>
                <table>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left">Persona física</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left">Persona moral</th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left">1.- Identificación oficial del cliente (vigente)</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left">1.- Acta constitutiva y/o poder notarial (con autorización para poder firmar títulos de crédito)</th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 2.- Comprobante de domicilio del cliente (no mayor a dos meses) </th>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 2.- Identificación oficial del representante legal </th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 3.- Carátula de identificación fiscal SAT (R.F.C.)</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 3.- Comprobante de domicilio del representante legal (no mayor a dos meses) </th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 4.- Identificación oficial del AVAL (vigente)</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 4.- Comprobante de domicilio de las empresas (no mayor a dos meses) </th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 5.- Comprobante de domicilio del AVAL (no mayor a dos meses)</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 5.- Carátula de identificación fiscal SAT (R.F.C.) </th>
                    </tr>
                    <tr>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 6.- Firma de contrato. Pagaré y aviso de privacidad</th>
                        <th class="letraContratacion" colspan="2" style="text-align: left"> 6.- Firma de contrato. Pagaré y aviso de privacidad</th>
                    </tr>
                </table>
                <hr>
                <ol class="letraImprimir">
                    <h4 class="letraImprimir" style="text-align: left"><strong>Clausulas de contratación:</strong></h4>
                    <li>Más de {{formIva}} de IVA</li>
                    <li>Custodia de los materiales durante el proceso de la obra</li>
                    <div *ngIf="btnImprimir; else clausulas">
                        <li>Montaje y desmontaje así como la responsabilidad en el uso del material</li>
                    </div>
                    <ng-template #clausulas>
                        <li>Responsabilidad en el uso del material</li>
                    </ng-template>
                    <li>Las entrada y salidas de los materiales deberán ser firmadas por un representante de ustedes</li>
                </ol>
                <br>
                <br>
                <table class="letraImprimir tablaMedida">
                    <tr>
                        <th colspan="3" style="text-align: center">____________________________</th>
                        <th colspan="3" style="text-align: center">____________________________</th>
                    </tr>
                    <tr>
                        <th class="letraImprimir" colspan="3" style="text-align: center">Firma Técnico: </th>
                        <th class="letraImprimir" colspan="3" style="text-align: center">Firma Cliente: </th>
                    </tr>
                </table>
            </div>
            <!-- ======================================= -->
            <!-- ============ PARA IMPRIMIR ============ -->
            <!-- ======================================= -->
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/ver-cotizacion/ver-cotizacion.component.html